module.exports = __webpack_public_path__ + "img/card-checklist-green.40e25bf5.svg";